<template>
  <w-setting-sliding-popup ref="slidingPopup" :title="popupTitle" width="750px" @close="close">
    <div slot="content">
      <!-- IP그룹 정보 설정 view -->
      <w-basic-info-setting-view v-show="currentView === 'basicInfoView'" :view-params="basicInfoParams" @change-view="changeView" @delete-ip="deleteIpList" ref="basicInfoView"/>
      <!-- IP추가 view -->
      <w-add-ipaddress-setting-view v-show="currentView === 'addIpaddressView'" :ip-version="ipVersion" @change-view="changeView" ref="addIpaddressView"/>
    </div>
    <div slot="footer">
      <!-- IP그룹 정보 설정 view -->
      <div v-show="currentView === 'basicInfoView'">
        <el-button size="large" type="solid" @click="onSaveButtonClick">저장</el-button>
        <el-button size="large" @click="close">취소</el-button>
      </div>
      <!-- IP추가 view -->
      <div v-show="currentView === 'addIpaddressView'">
        <el-button size="large" type="solid" @click="onAddButtonClick">추가</el-button>
        <el-button size="large" @click="changeView('basicInfoView')">취소</el-button>
      </div>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import { isEmpty, isNil, unionBy } from 'lodash';
import { matcher } from '@/utils/string';
import trafficAPI from '@/api/settings/netdevice/traffic-settings';
import WBasicInfoSettingView from '../components/BasicInfoSettingView';
import WAddIpaddressSettingView from '../components/AddIpaddressSettingView';

export default {
  name: 'WIpGroupSettingSlidingPopup',
  components: {
    WBasicInfoSettingView,
    WAddIpaddressSettingView,
  },
  props: {
    popupParams: Object,
  },
  data() {
    return {
      popupVisible: false,
      popupTitle: '',
      currentView: 'basicInfoView',
      ipVersion: 'IPv4',
      basicInfoParams: { orderbyIndex: 0, selectedRecord: {}, ipList: [] }, // 기본정보 화면에 필요한 params
      subnetMaskInfo: {}, // 서브넷 마스크 연산위해
    };
  },
  methods: {
    open() {
      this.popupVisible = true;
      this.$refs.slidingPopup.visible = true;

      if (this.popupParams.popupType === 'ADD') {
        const ipGroupList = this.popupParams.ipGroupList;
        this.basicInfoParams.orderbyIndex = ipGroupList.length > 0 ? ipGroupList[ipGroupList.length - 1].orderbyIndex + 1 : 1;
        this.popupTitle = 'IP그룹 추가';
      } else if (this.popupParams.popupType === 'UPDATE') {
        const selectedRecord = this.popupParams.selectedRecord;
        trafficAPI.getIpGroupIpList({ ipGroupId: selectedRecord.ipGroupId }).then((response) => {
          if (response.data.success) {
            const ipList = response.data.data;
            this.basicInfoParams.selectedRecord = { ipList, ...selectedRecord };
            this.basicInfoParams.ipList = ipList;
            this.popupTitle = `[ ${selectedRecord.ipGroupName} ] IP그룹 정보`;
          }
        });
      }
    },
    close() {
      this.popupVisible = false;
      this.$refs.slidingPopup.visible = false;

      this.changeView('basicInfoView');
      this.$refs.basicInfoView.initData();
      this.basicInfoParams = { orderbyIndex: 0, selectedRecord: {}, ipList: [] };
    },
    /**
     * 기본정보 <-> IP추가 화면 변경
     * @author jeee12
     * @param  {[type]} viewType  기본정보 or IP추가 화면 타입
     * @param  {[type]} ipVersion ip버전 (IP추가 화면에 전달 위해)
     */
    changeView(viewType, ipVersion) {
      if (ipVersion) this.ipVersion = `IPv${ipVersion}`;
      this.currentView = viewType;
      if (viewType === 'basicInfoView') {
        this.$refs.addIpaddressView.initData(viewType);
      }
    },
    /**
     * 자식(BasicInfoSettingView)에서 삭제한 IP목록을 부모로 동기화
     * @author jeee12
     * @param  {[type]} ipList [description]
     * @return {[type]}        [description]
     */
    deleteIpList(ipList) {
      this.basicInfoParams.ipList = ipList;
    },
    /**
     * 기본정보 > 저장 버튼 click
     * @author jeee12
     * @return {[type]} [description]
     */
    onSaveButtonClick() {
      const ipGroupSettingInfo = this.$refs.basicInfoView.getIpGroupBasicInfo();
      ipGroupSettingInfo.validate().then((response) => {
        if (response) {
          if (ipGroupSettingInfo.basicInfo.ipList && ipGroupSettingInfo.basicInfo.ipList.length === 0) {
            this.$message(msgUtil.getCustomMsgData('IP 주소를 추가해주십시오.'));
          } else {
            this.$confirm('저장하시겠습니까?', '확인', {
              confirmButtonText: '확인',
              cancelButtonText: '취소',
            }).then(() => {
              if (!isEmpty(ipGroupSettingInfo.basicInfo)) {
                // 추가 또는 수정된 항목 존재시
                const saveType = this.popupParams.popupType.toLowerCase();
                // 추가 또는 수정 (addIpGroup, updateIpGroup)
                trafficAPI[`${saveType}IpGroup`](ipGroupSettingInfo.basicInfo).then((res) => {
                  if (res.data.success) {
                    this.$alert('IP 그룹을 저장하였습니다.', '정보', {
                      callback: () => {
                        this.$emit('reload');
                      },
                    });
                  }
                });
              }
              this.close();
            }).catch(() => {});
          }
        }
      }).catch(() => {});
    },
    /**
     * IP 추가 > 추가 버튼 click
     * @author jeee12
     * @return {[type]} [description]
     */
    onAddButtonClick() {
      const addIpInfo = this.$refs.addIpaddressView.getIpaddressInfo();
      addIpInfo.validate().then((response) => {
        if (response) {
          let params;
          let startIp;
          let endIp;

          if (addIpInfo.addType === 'ipaddress') {
            params = { searchKeyword1: addIpInfo.formData.searchKeyword1 };
            startIp = this.getIpaddress(null, addIpInfo.formData.searchKeyword1);
            endIp = startIp;
          } else if (addIpInfo.addType === 'iprange') {
            params = addIpInfo.formData;
            startIp = this.getIpaddress(null, addIpInfo.formData.searchKeyword1);
            endIp = this.getIpaddress(null, addIpInfo.formData.searchKeyword2);
          } else if (addIpInfo.addType === 'subnetmask') {
            this.subnetMaskInfo = { startIp: addIpInfo.formData.searchKeyword1, subnetmask: addIpInfo.formData.searchKeyword2 };
            const calcResult = this.calculateSubnetMask();
            params = { searchKeyword1: calcResult.startIp, searchKeyword2: calcResult.endIp };
            startIp = calcResult.intData.startIp;
            endIp = calcResult.intData.endIp;
          }

          trafficAPI.getMatchedIpaddress(params).then((res) => {
            if (res.data.success) {
              const ipList = res.data.data;
              let ipRecords;
              if (addIpInfo.ipVersion === 'IPv4') {
                ipRecords = this.createIpRecords(startIp, endIp, ipList);
              } else if (addIpInfo.ipVersion === 'IPv6') {
                if (!isEmpty(ipList)) {
                  ipRecords = ipList;
                } else {
                  ipRecords = [{ netIpaddress: addIpInfo.formData.searchKeyword1, hostName: '' }];
                }
              }
              this.basicInfoParams.ipList = unionBy(this.basicInfoParams.ipList, ipRecords, 'netIpaddress');
              this.changeView('basicInfoView');
            }
          });
        }
      }).catch(() => {});
    },
    /* eslint-disable no-bitwise */ // 비트연산자 eslint 위반
    /**
     * IP주소 연산
     * @author jeee12
     * @param  {[type]} startIp [description]
     * @param  {[type]} endIp   [description]
     * @param  {[type]} ipList  [description]
     * @return {[type]}         [description]
     */
    createIpRecords(startIp, endIp, ipList) {
      const ipRecords = [];
      let part1;
      let part2;
      let part3;
      let part4;
      if (isEmpty(ipList)) {
        for (let ip = startIp; ip <= endIp; ip += 1) {
          part1 = ip & 255;
          part2 = ((ip >> 8) & 255);
          part3 = ((ip >> 16) & 255);
          part4 = ((ip >> 24) & 255);
          ipRecords.push({ netIpaddress: `${part4}.${part3}.${part2}.${part1}`, hostName: '' });
        }
      } else {
        const ipMap = {};
        ipList.forEach((ip) => {
          const strIpaddress = ip.netIpaddress;
          ipMap[strIpaddress] = ip;
        });

        for (let ip = startIp; ip <= endIp; ip += 1) {
          if (isEmpty(ipMap[ip])) {
            part1 = ip & 255;
            part2 = ((ip >> 8) & 255);
            part3 = ((ip >> 16) & 255);
            part4 = ((ip >> 24) & 255);
            const strIpaddress = `${part4}.${part3}.${part2}.${part1}`;
            ipRecords.push({
              netIpaddress: strIpaddress,
              hostName: ipMap[strIpaddress] ? ipMap[strIpaddress].hostName : '',
            });
          } else {
            ipRecords.push(ipMap[ip]);
          }
        }
      }
      return ipRecords;
    },
    /**
     * 서브넷 마스크 연산
     * @author jeee12
     * @return {[type]} [description]
     */
    calculateSubnetMask() {
      const subnetMask = this.getBitMask(this.subnetMaskInfo.subnetmask);

      const intData = this.getIpaddress(subnetMask, this.subnetMaskInfo.startIp);
      let part1;
      let part2;
      let part3;
      let part4;
      part1 = intData.startIp & 255;
      part2 = ((intData.startIp >> 8) & 255);
      part3 = ((intData.startIp >> 16) & 255);
      part4 = ((intData.startIp >> 24) & 255);

      const startStrIp = `${part4}.${part3}.${part2}.${part1}`;


      part1 = intData.endIp & 255;
      part2 = ((intData.endIp >> 8) & 255);
      part3 = ((intData.endIp >> 16) & 255);
      part4 = ((intData.endIp >> 24) & 255);
      const endStrIp = `${part4}.${part3}.${part2}.${part1}`;

      return {
        startIp: startStrIp,
        endIp: endStrIp,
        intData,
      };
    },
    getBitMask(ipaddress) {
      let ip = ipaddress;
      if (!matcher.integer().test(ipaddress)) {
        ip = this.getIpaddress(null, ipaddress);
      }

      let bitMask;
      if (!isNil(ip)) {
        for (bitMask = 0; ip !== 0; bitMask += 1) {
          ip &= (ip - 1);
        }
      } else {
        bitMask = null;
      }

      return bitMask;
    },
    getIpaddress(subnetMask, value) {
      const IP_BYTE_COUNT = 4;
      const field = { useStrict: true };

      let result;
      if (!isNil(value)) {
        let ip = value;
        const ipBytes = ip.split('.');
        let endIp;
        const isIpRange = !field.useStrict && ((ipBytes.length !== IP_BYTE_COUNT) || (ipBytes.length === IP_BYTE_COUNT && isNil(ipBytes[IP_BYTE_COUNT - 1])));

        if (isIpRange) {
          endIp = ip;
          for (let i = (ipBytes.length - 1); i < IP_BYTE_COUNT; i += 1) {
            if (isNil(ipBytes[i])) {
              ip += '0';
              endIp += '255';
            }

            if (i < IP_BYTE_COUNT - 1) {
              ip += '.';
              endIp += '.';
            }
          }
        }

        const ipNumber = this.ipv4ToLong(ip);
        if (!isNil(subnetMask)) {
          result = {
            startIp: ipNumber,
            endIp: this.calcIpRange(ipNumber, subnetMask),
          };
        } else if (isIpRange) {
          result = {
            startIp: ipNumber,
            endIp: this.ipv4ToLong(endIp),
          };
        } else if (field.useStrict) {
          result = ipNumber;
        } else {
          result = { ipaddress: ipNumber };
        }
      }

      return result;
    },
    ipv4ToLong(ipv4) {
      let ipNum = 0;
      const ipArray = ipv4.split('.');
      for (let i = 3; i >= 0; i -= 1) {
        const ipaddr = parseInt(ipArray[3 - i], 10);
        ipNum |= ipaddr << (i * 8);
      }
      return ipNum >>> 0;
    },
    calcIpRange(ipv4, subnetMask) {
      let subnetMaskValue = subnetMask;
      if (isNil(subnetMask)) {
        const ipClass = this.getIpClass(ipv4);
        subnetMaskValue = this.getDefaultSubnetMask(ipClass);
      }

      return (ipv4 + (2 ** (32 - subnetMaskValue))) - 1;
    },
    getIpClass(ipv4) {
      const firstByte = ((ipv4 >> 24) & 255);
      let ipClass;
      if (firstByte >= 0 && firstByte <= 127) {
        ipClass = 'A';
      } else if (firstByte >= 128 && firstByte <= 191) {
        ipClass = 'B';
      } else if (firstByte >= 192 && firstByte <= 223) {
        ipClass = 'C';
      } else if (firstByte >= 224 && firstByte <= 239) {
        ipClass = 'D';
      } else if (firstByte >= 240 && firstByte <= 255) {
        ipClass = 'E';
      }

      return ipClass;
    },
    getDefaultSubnetMask(ipClass) {
      let subnetMask;
      switch (ipClass) {
        case 'A': subnetMask = 8; break;
        case 'B': subnetMask = 16; break;
        case 'C': subnetMask = 24; break;
        default: break;
      }

      return subnetMask;
    },
    /* eslint-enable no-bitwise */
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/TrafficSettings/IpGroupSettings/popup/IpGroupSettingSlidingPopup.vue